export const SliderData = [
  {
    image: "https://i.ibb.co/Lr0x7rp/lorry.webp",
  },
  {
    image:
      "https://i.ibb.co/gT25xB1/corina-ardeleanu-s-Wlx-Cwe-Dzzs-unsplash.webp",
  },
  {
    image: "https://i.ibb.co/6Nq8sTx/christin-hume-Hcfwew744z4-unsplash.webp",
  },
];
